import React from 'react';
import type { BoxProps as ThemeBoxProps } from 'theme-ui';
import { Box as ThemeBox } from 'theme-ui';
import styles from '~/ui/styles';

export interface BoxProps extends ThemeBoxProps {
    'data-popper-arrow'?: boolean;
    disabled?: boolean;
}

/**
 * @deprecated Wraps theme-ui, which is being removed from this codebase. Do not use in new code.
 */
// eslint-disable-next-line @typescript-eslint/no-shadow -- named function expression keeps the React display name
const Box = React.forwardRef<HTMLDivElement, BoxProps>(function Box(
    { sx, ...extra },
    ref
) {
    const clickableStyles =
        extra.disabled || extra.onClick ? styles.interactions.clickable : {};
    return <ThemeBox ref={ref} sx={{ ...clickableStyles, ...sx }} {...extra} />;
});

export default Box;
